import { Box, Flex, VStack } from '@chakra-ui/react';
import { BigNumber } from '@ethersproject/bignumber';
import useBaraVaultUserInfo from '@ui/hooks/contracts/BaraVault/useBaraVaultUserInfo';
import type { VaultCardInfo } from '@ui/interfaces/vault.interface';
import { useTranslations } from 'next-intl';
import { type PropsWithChildren, useMemo } from 'react';

import { Subtitle } from '../AprSubTitle';
import DepositUnlockLabel from '../DepositUnlockLabel';
import { StakeInfoToken } from '../StakaInfoToken';
import UnlockDate from '../UnlockDate';
import { VaultCardLeftBody } from '../VaultCardLeftBody';

export const VaultCardConnected = (props: PropsWithChildren<VaultCardInfo>) => {
  const { pid } = props;
  const { data } = useBaraVaultUserInfo();
  const t = useTranslations();
  const earliestunLockTimestamp = useMemo(() => {
    if (!data) return BigNumber.from(0);
    const currentPoolStake = data.poolStakeMap[pid];

    return currentPoolStake.reduce<BigNumber>((acc, stake) => {
      if (stake.active && acc.isZero() && !stake.isUnlocked) {
        return stake.unlockTimestamp;
      }
      if (stake.active && stake.unlockTimestamp.lte(acc)) {
        return stake.unlockTimestamp;
      }
      return acc;
    }, BigNumber.from(0));
  }, [data, pid]);

  return (
    <>
      <VaultCardLeftBody>
        <VStack flexGrow={1} mb={1} h="full" alignItems="self-start" gap={1}>
          <Subtitle mb={1}>{t('common.You have staked')}</Subtitle>
          <Box w="full">
            <StakeInfoToken
              value={data?.poolTotalStakeMap[pid]}
              placeholder={t('common.No $BARA staked')}
              textProps={{ textStyle: 'h6' }}
            />
          </Box>
        </VStack>
      </VaultCardLeftBody>
      {!data?.poolTotalStakeMap[pid].isZero() && (
        <Flex mt="auto" w="full">
          {/* <StakeInfoDollar value={totalStakedUsd} hideWhenZero mt={1} /> */}
          <UnlockDate unlockTimestamp={earliestunLockTimestamp} isInVaultCard />
          {earliestunLockTimestamp.isZero() && (
            <DepositUnlockLabel isInVaultCard />
          )}
        </Flex>
      )}
    </>
  );
};

export default VaultCardConnected;
